import 'jquery'
import 'bootstrap'

import Vue from 'vue'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import CurrencyFormatter from 'currency-formatter'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import { BigNumber } from 'bignumber.js'
import VueClipboard from 'vue-clipboard2'
import VueToastr from 'vue-toastr'
import BlockUI from 'vue-blockui'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'
import store from './store'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'

window.$ = window.jQuery = require('jquery')

require('./assets/plugins/perfect-scrollbar/dist/css/perfect-scrollbar.min.css')
require('./assets/plugins/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css')
require('./assets/css/style.css')
require('./assets/css/icofont.css')
require('./assets/css/vue-multiselect.css')
require('./assets/plugins/horizontal-timeline/horizontal-timeline.css')
require('./assets/css/custom.css')
require('./assets/js/app')
require('./assets/js/app-style-switcher')
require('./assets/js/waves.js')
require('./assets/plugins/perfect-scrollbar/dist/perfect-scrollbar.jquery.min')
require('./assets/plugins/sparkline/sparkline.js')
require('./assets/plugins/bootstrap-datepicker/dist/js/bootstrap-datepicker.min')
require('./assets/plugins/horizontal-timeline/horizontal-timeline.js')

Vue.config.productionTip = false

Vue.prototype.$API_URL = process.env.VUE_APP_API_URL
Vue.prototype.$ACCOUNTS_URL = process.env.VUE_APP_ACCOUNTS_URL
Vue.prototype.$BORLAUG = process.env.VUE_APP_BORLAUG
Vue.prototype.$SITE_URI = process.env.VUE_APP_SITE_URI
Vue.prototype.$TIMEOUT = process.env.VUE_APP_TIMEOUT

Vue.use(Vue2Filters)
Vue.use(VeeValidate, {
  fieldsBagName: 'vee-fields'
})
Vue.use(VueSweetalert2)
Vue.use(VueClipboard)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000
})
Vue.use(BlockUI)
Vue.use(Toast, {
  position: 'top-right',
  timeout: Number(Vue.prototype.$TIMEOUT),
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: {
    iconClass: 'fas fa-spinner fa-spin fa-2x',
    iconChildren: '',
    iconTag: 'i'
  },
  rtl: false
})
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

//      FOR BWS-ACCOUNTS APIS       //
Vue.prototype.$accounts = axios.create({
  baseURL: Vue.prototype.$ACCOUNTS_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
Vue.prototype.$accounts.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  config.headers.Authorization = `Bearer ${token}`
  return config
}, function (error) {
  return Promise.reject(error)
})
Vue.prototype.$accounts.interceptors.response.use((res) => {
  return res
}, function (error) {
  if (error.response && error.response.status === 401) {
    window.location.href = '/auth/login'
  }
  return Promise.reject(error)
})

//      FOR BWS-AUDITS APIS       //
Vue.prototype.$api = axios.create({
  baseURL: Vue.prototype.$API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
Vue.prototype.$api.interceptors.request.use(async (config) => {
  // if (process.env.EMULATE_SLOW) {
  //     console.log('waiting 15 seconds');
  //     await new Promise(resolve => setTimeout(resolve, 15000));
  // }
  const token = localStorage.getItem('token')
  config.headers.Authorization = `Bearer ${token}`
  config.headers['API-wallet-id'] = store.state.active_wallet_id
  if (!config.headers['API-group-id']) {
    if (!config.url.includes('/groups/')) {
      config.headers['API-group-id'] = store.state.active_group_id
    } else {
      delete config.headers['API-group-id']
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
Vue.prototype.$api.interceptors.response.use((res) => {
  return res
}, function (error) {
  console.log(error.response.data.error_type)
  if (error.response && error.response.status === 401 && error.response.data && error.response.data.error_type === 'AuthorizationError') {
    window.location.href = '/groups'
  } else if (error.response && error.response.status === 401) {
    window.location.href = '/auth/login'
  }
  return Promise.reject(error)
})

Vue.prototype.$apiFile = axios.create({
  baseURL: Vue.prototype.$API_URL,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})
Vue.prototype.$apiFile.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  config.headers.Authorization = `Bearer ${token}`
  config.headers['API-wallet-id'] = store.state.active_wallet_id

  if (!config.url.includes('/groups/')) {
    config.headers['API-group-id'] = store.state.active_group_id
  } else {
    delete config.headers['API-group-id']
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
Vue.prototype.$apiFile.interceptors.response.use((res) => {
  return res
}, function (error) {
  if (error.response && error.response.status === 401) {
    window.location.href = '/auth/login'
  }
  return Promise.reject(error)
})
Vue.prototype.$showError = (e, msg) => {
  let message;
  if (e.response) {
    console.error(e.response.data);
    if (e.response.data.message) {
      message = e.response.data.message;
    } else {
      message = 'Unexpected response from server';
    }
  } else {
    console.error(e);
    message = 'Unable to connect to server.';
  }
  Vue.prototype.$toastr.e(`${msg ? msg : 'An error occured.'}<br>${message}`, 'Error');
};

//      FILTER SECTION      //
Vue.filter('currency', function (value, code) {
  if (!value) return ''
  value = value.toString()
  return CurrencyFormatter.format(new BigNumber(value).toNumber(), { code: code || 'USD' })
})
Vue.filter('count', function (value) {
  if (!value) return ''
  return new BigNumber(value).toFormat(2)
})
Vue.filter('fromNow', function (dateString) {
  if (!dateString) return ''
  return moment(dateString).fromNow()
})
Vue.filter('date', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('MMMM Do YYYY')
})
Vue.filter('timestamp', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('MMMM Do YYYY, h:mm:ss a')
})
Vue.filter('short', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('MMM Do YYYY, h:mm a')
})
Vue.filter('medium', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('MMM Do YYYY')
})
Vue.filter('long', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('MMM Do, h:mm a')
})
Vue.filter('timeline', function (dateString) {
  if (!dateString) return ''
  return moment(Date.parse(dateString)).format('DD/MM/YYYY')
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
})
Vue.filter('lowercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
})
Vue.filter('truncate', function (text, length, suffix) {
  if (text) {
    if (text.length <= length) return text
    return text.substring(0, length) + suffix
  }
})
Vue.filter('hex_format', function (text, length, suffix) {
  if (text) {
    if (text.length <= length) return text
    return text.substring(0, length) + suffix + text.substring(text.length - length)
  }
})
Vue.filter('epoch', function (epochString) {
  return moment.unix(epochString).format('MMM Do YYYY')
})

Vue.filter('formatGRAM', function (n) {
  n /= 1e6
  if (n < 1e6) return Number(n).toLocaleString() + ' GRAM'
  if (n >= 1e6 && n < 1e9) return Number(n / 1e6).toLocaleString() + ' MGRAM'
  if (n >= 1e9 && n < 1e12) return Number(n / 1e9).toLocaleString() + ' BGRAM'
  if (n >= 1e12) return Number(n / 1e12).toLocaleString() + ' TGRAM'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
